/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const WHOLE_FESTIVAL: CommunityData = {
  code: "wholefestival",
  inviteCode: "wholefestival",
  name: "WHOLE Festival",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/wholefestival`,
  socials: {},
  styles: {
    global: {
      mobileOnly: true,
      counterColor: "#1e6ed0",
      logo: {
        src: "https://media.werz.at/community-assets/wholefestival/web-logo.png",
        styles: "w-[196px] h-[50px]",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/wholefestival/web-alternative-logo.png",
        styles: "w-[196px] h-[50px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#f5f7e9",
      asideBg: "transparent",
      asideStyles: "border-r border-[#1e6ed0]",
      contentBg: "#f5f7e9",
      contentBoxShadow: "",
      bgDesktop:
        "https://media.werz.at/community-assets/wholefestival/web-background.mp4?type=video",
      bgMobile:
        "https://media.werz.at/community-assets/wholefestival/web-background-mobile.mp4?type=video",
      nonMemberBg:
        "https://media.werz.at/community-assets/wholefestival/web-background-non-member.mp4?type=video",
      mainFont: "font-['OCRATributeW01-RegularMonoRegular']",
      primaryButton:
        "bg-[#191818] border border-[#191818] rounded-lg px-[18px] py-[18px] !text-[#ffffff] font-['OCRATributeW01-RegularMonoRegular'] !text-[14px] uppercase text-left",
    },
    navigation: {
      iconsColor: "#1e6ed0",
      sideBarSeparator: "border-r-[1px] border-[#1e6ed0]",
      separator: "#1e6ed040",
      item: "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left gap-x-[10px] text-opacity-50 !pl-0 !py-2",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#f5f7e9] border border-[#a7a7a7] rounded-3xl !pb-8 overflow-hidden",
      titles: "text-[#1e6ed0] font-['KarlSTBlack'] text-[26px] uppercase text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle:
          "text-[#1e6ed0] font-['KarlSTBlack'] text-[26px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[256px] max-w-[256px] bg-[#f5f7e9] border border-[#a7a7a7] overflow-hidden",
          mediaContainer: "w-[256px] h-[256px] relative",
          media: "w-[256px] h-[256px] object-cover",
          placeholderMedia: "w-[256px] h-[256px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title:
            "text-[#1e6ed0] font-['KarlSTBlack'] text-[14px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle:
          "text-[#1e6ed0] font-['KarlSTBlack'] text-[26px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full bg-[#f5f7e9] border border-[#a7a7a7] overflow-hidden",
          mediaContainer: "w-full sm:!w-[228px] sm:!h-[128px] sm:flex-shrink-0 relative",
          media: "w-full sm:!w-[228px] sm:!h-[128px] !aspect-video object-cover",
          placeholderMedia: "w-full sm:!w-[228px] sm:!h-[128px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title:
            "text-[#1e6ed0] font-['KarlSTBlack'] text-[14px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%]",
          location:
            "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%]",
          date: "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#1e6ed0] font-['KarlSTBlack'] text-[22px] uppercase text-left leading-[120%]",
        text: "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] text-left leading-[120%]",
        customShopImageStyle: "border border-[#191818] rounded-xl",
        sectionTitle:
          "text-[#1e6ed0] font-['KarlSTBlack'] text-[26px] uppercase text-left leading-[120%] !mb-4 sm:!mb-4",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#f5f7e9] border border-[#a7a7a7] rounded-3xl !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media:
          "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 border border-[#191818] rounded-xl",
        title: "text-[#1e6ed0] font-['KarlSTBlack'] text-[26px] uppercase text-left leading-[120%]",
        subtitle:
          "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#191818] border border-[#191818] rounded-lg px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left leading-[100%]",
        questions: "text-[12px] text-left leading-[120%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#1e6ed0] font-['KarlSTBlack'] text-[22px] uppercase text-left leading-[120%]",
        text: "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#1e6ed0] font-['KarlSTBlack'] text-[22px] uppercase text-left leading-[120%]",
        text: "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] border border-[#6d6d6d] rounded-2xl",
        mapPinColor: "#1e6ed0",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#1e6ed0] font-['KarlSTBlack'] text-[22px] uppercase text-left leading-[120%]",
        text: "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#1e6ed0] font-['KarlSTBlack'] text-[26px] uppercase text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#f5f7e9] border border-[#a7a7a7] rounded-3xl !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#c8ff00] border border-[#ffffff00] rounded-lg !px-4 !py-4 text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto bg-[#f5f7e9] border border-[#a7a7a7] mb-4 p-4 overflow-hidden",
          media: "!hidden",
          name: "text-[#1e6ed0] font-['KarlSTBlack'] text-[14px] uppercase text-left leading-[120%]",
          description:
            "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] text-left leading-[120%] !mt-1",
          price:
            "text-[#1e6ed0] font-['KarlSTBlack'] text-[14px] uppercase text-left leading-[120%] !mt-1",
          status:
            "text-[#ed3737] font-['KarlSTBlack'] text-[14px] uppercase text-left leading-[120%]",
          counterContainer:
            "bg-[#c8ff00] border border-[#ffffff00] rounded-lg !px-4 !py-4 gap-x-4 !w-fit",
          quantity:
            "text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] uppercase text-left leading-[100%]",
          button:
            "!bg-[#c8ff00] border border-[#ffffff00] rounded-lg !px-4 !py-4 text-[#1e6ed0] font-['OCRATributeW01-RegularMonoRegular'] text-[12px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#1e6ed0",
        },
      },
    },
  },
}

export default WHOLE_FESTIVAL
